// src/components/input/InputCheck.js
import { useId } from 'react';
import './InputCheck.css';

const InputCheck = ({ id, label, checked, onChange, disabled }) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  return (
  <div className="form-check infomaio-input-check">
    <input
      type="checkbox"
      className="form-check-input"
      id={inputId}
      checked={checked !== null ? checked : false}//Se for null checked é false
      onChange={onChange}
      disabled={disabled}
    />
    <label className="form-check-label" htmlFor={inputId}>
      {label}
    </label>
  </div>
  );
};

export default InputCheck;
